const Kategoriya2313 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 3-chorak<br />
                Mavzu: Gap <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Juftlikda ishlang. Quyidagi vaziyatni o‘qing va gap tuzing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning gap tuzish haqidagi ko‘nikmalarini rivojlantirish.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3-4 daqiqa <br />
            <p className="text-break">Oila davrasida - ________________________________________________</p>
            <p className="text-break">Hasharda - ____________________________________________________</p>
            <p><b>2-mashq.  So‘zlarning ma’nodoshlarini toping va nuqtalar o‘rniga mos so‘zni yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning so‘z ma’nolari ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Kulgi - _______________________________________________________</p>
            <p className="text-break">Nafisa chiroyli _____________ qildi.</p>
            <p className="text-break">Ovqat - _______________________________________________________</p>
            <p className="text-break">Yaxshi pishirilgan _____________ oshqozong og‘ir botmaydi.</p>
            <p><b> 3-mashq. FDM usulidan foydalanib, gap haqida fikrlar yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning gap haqidagi grammatik bilimlarini mustahkamlash.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2313;